export default "__VITE_ASSET__f2d739ae__"